// import { ReCaptcha } from "react-google-recaptcha-v3";
import { fetchAction } from "../utils";

const APP_BASE_URL = process.env.REACT_APP_BASE_URL;

export const sendMessage = ({ email, customerName, message, authToken }) => {
  // alert("1")
  return fetchAction({
    type: "SEND_MESSAGE",
    headers: { contentType: "includeBearer" },
    verb: "POST",
    endpoint: `https://gateway.findanexpert.net/email_svc/pb/send/chelsford`,
    payload: JSON.stringify({
      email: email,
      firstName: customerName,
      lastName: "",
      message: message,
      recaptchaToken: authToken,
    }),
  });
};

export const makeSendMessageFalse = () => {
  return {
    type: "MAKE_SEND_MESSAGE_FALSE",
  };
};

